import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {
    fieldCategoryFromPath,
    type FieldCategoryKey
} from './fieldCategories';

/** What the field chrome needs to know about where the user is. */
export interface FieldRoute {
    pathname: string;
    /** The open project, or null on the picker page. */
    projectId: string | null;
    /** The open Befund, or null outside one. */
    findingId: string | null;
    category: FieldCategoryKey | null;
}

/**
 * The open project/Befund/category, read off the URL: the chrome sits above the
 * pages, so it can't be handed them as props.
 */
export function useFieldRoute(): FieldRoute {
    const { pathname } = useLocation();
    return useMemo(() => {
        const projectMatch = pathname.match(/^\/field\/([^/]+)/);
        const findingMatch = pathname.match(
            /^\/field\/[^/]+\/findings\/([^/]+)/
        );
        return {
            pathname,
            projectId: projectMatch ? projectMatch[1] : null,
            findingId: findingMatch ? findingMatch[1] : null,
            category: fieldCategoryFromPath(pathname)
        };
    }, [pathname]);
}
